import { Injectable } from '@angular/core';
import { SensorGraph } from '../models/sensor-graph.model';
import { DashboardEvents } from '../enums/dashboard-events.enum';
import { BroadcastService } from '../../../common/services/broadcast/broadcast.service';
import { Subject } from 'rxjs';
import { PinnedGraph } from 'src/app/modules/favorite/models/favorite';

@Injectable({
    providedIn: 'root'
})
export class PinUnpinService {

    //
    public pinnedGraphsCountChanged = new Subject<number>();

    public get pinnedGraphs(): PinnedGraph[] {
        return this.mergeTwoArrays(this._pinnedGraphs, this._pinnedFavoriteGraphs);
    }

    private _pinnedGraphs: PinnedGraph[] = [];
    private _pinnedFavoriteGraphs: PinnedGraph[] = [];

    constructor(private broadcastService: BroadcastService,) {
        this.unpinAllGraphs();
    }

    public addOrRemoveG(graph: PinnedGraph, arr: PinnedGraph[]) {
        const existingIndex = arr.findIndex(g => g.graphId === graph.graphId && g.locationId === graph.locationId);

        if (existingIndex === -1) {
            arr.push(graph);
        } else {
            arr.splice(existingIndex, 1);
        }
        this.pinnedGraphsCountChanged.next(this.pinnedGraphs.length);
    }

    public isGraphPinned(graph: PinnedGraph) {
        if (!graph || !this._pinnedGraphs) {
            return false;
        }
        return !!this._pinnedGraphs.find(g => g.graphId === graph.graphId && g.locationId === graph.locationId);
    }

    public unpinAllGraphs() {
        this._pinnedGraphs = [];
        this._pinnedFavoriteGraphs = [];
        this.broadcastService.broadcast(DashboardEvents.UnpinAll);
        this.pinnedGraphsCountChanged.next(0);
    }

    public replacePinnedGraph(graph: PinnedGraph) {
        if (!graph) {
            return;
        }

        const pinnedIndex = this._pinnedGraphs.findIndex(g => g.graphId === graph.graphId);
        const pinnedFavoriteIndex = this._pinnedFavoriteGraphs.findIndex(g => g.graphId === graph.graphId);

        // if (pinnedIndex > -1) {
        //     this._pinnedGraphs[pinnedIndex].points = graph.points;
        // }
        // // "else if" only because we are merging them in get pinnedGraphs method and its unnecessary to change both
        // else if (pinnedFavoriteIndex > -1) {
        //     this._pinnedFavoriteGraphs[pinnedFavoriteIndex].points = graph.points;
        // }
    }

    public unpinAllFavoriteGraphs() {
        let doBroadcast = false;
        if (this._pinnedFavoriteGraphs.length) {
            doBroadcast = true;
        }
        this._pinnedFavoriteGraphs = [];
        if (doBroadcast) {
            this.pinnedGraphsCountChanged.next(this.pinnedGraphs.length);
        }
    }

    public addOrRemoveGraph(graph: PinnedGraph) {
        this.addOrRemoveG(graph, this._pinnedGraphs);
    }
    public addOrRemoveFavoriteGraph(graph: PinnedGraph) {
        this.addOrRemoveG(graph, this._pinnedFavoriteGraphs);
    }

    private mergeTwoArrays(a1: PinnedGraph[], a2: PinnedGraph[]) {
        const res = [...a1];
        a2.forEach(g2 => {
            if (!res.find(r => r.graphId === g2.graphId)) {
                res.push(g2);
            }
        });
        return res;
    }
}
